/* 05 Luggage sets (sections/ez-sets.liquid), homepage v2, SPEC section 8.
   The rows step every data-interval ms (3.2 s) on EZH.stepper: the stage photo slides 40 px and crossfades (0.9 s),
   the caption fades in after 0.25 s, and a red bar fills under the active row. A row click jumps there and carries
   on with a full step. Stops only for its pause pill, pause all, keyboard focus inside the selector, the selector
   being under 20% on screen, or a hidden tab; a resting mouse never stops it. Reduced motion: manual only (the
   stepper holds and hides the pill). Stage photos after the first load 700 px before the section scrolls in. */
(function () {
  'use strict';

  function setup(root) {
    var E = window.EZH;
    if (!E || !root || root.__ezsSets) return;
    var st = root.querySelector('[data-ezs-st]');
    if (!st) return;
    var rows = [].slice.call(root.querySelectorAll('[data-ezs-row]'));
    var imgs = [].slice.call(root.querySelectorAll('.ezs-img'));
    var caps = [].slice.call(root.querySelectorAll('.ezs-cap'));
    var n = rows.length;
    if (!n) return;
    var outTimers = [];

    function bar(k) {
      rows.forEach(function (r) { var b = r.querySelector('.ezs-pc__bar i'); if (b) b.classList.remove('is-run'); });
      var b = rows[k] && rows[k].querySelector('.ezs-pc__bar i');
      if (!b) return;
      void b.offsetWidth;                       // restart the fill from 0
      b.classList.add('is-run');
    }

    function show(k, p) {
      var a = imgs[k], o = imgs[p];
      if (a) E.warm(a);
      if (o && o !== a) {
        o.classList.remove('is-on'); o.classList.add('is-out');
        clearTimeout(outTimers[p]);
        outTimers[p] = setTimeout(function () { o.classList.remove('is-out'); }, 950);
      }
      if (a) { clearTimeout(outTimers[k]); a.classList.remove('is-out'); a.classList.add('is-on'); }
      // the outgoing caption stays clickable while it fades (.2 s), the incoming one only once it shows (CSS), so a
      // click always lands on the caption the shopper can see
      caps.forEach(function (c, j) {
        var on = j === k, was = c.classList.contains('is-on');
        clearTimeout(c.__ezsT);
        c.classList.toggle('is-on', on);
        if (on) { c.inert = false; c.removeAttribute('aria-hidden'); }
        else {
          c.setAttribute('aria-hidden', 'true');
          if (was && !E.reduced) c.__ezsT = setTimeout(function () { c.inert = true; }, 200); else c.inert = true;
        }
      });
      rows.forEach(function (r, j) {
        r.classList.toggle('is-on', j === k);
        r.setAttribute('aria-pressed', j === k ? 'true' : 'false');
      });
      bar(k);
    }

    var s = E.stepper(root, {
      count: n,
      interval: parseInt(root.getAttribute('data-interval'), 10) || 3200,
      threshold: 0.2,
      observe: st,
      focusRoot: st,
      show: show
    });
    root.__ezsSets = s;

    rows.forEach(function (r, j) {
      r.addEventListener('click', function () {
        if (j === s.index) bar(j);              // same row: the step restarts, so does its bar
        s.go(j);
      });
    });

    // warm every stage photo 700 px before the section arrives, so a step never shows an empty stage
    E.onVisible(root, function (v) { if (v) imgs.forEach(function (im) { E.warm(im); }); }, { margin: '700px 0px', once: true });

    // theme editor: selecting a row block shows that row and holds it there until it is deselected
    root.addEventListener('shopify:block:select', function (e) {
      var k = rows.indexOf(e.target);
      if (k > -1) { s.go(k); s.mover.hold('editor', true); }
    });
    root.addEventListener('shopify:block:deselect', function () { s.mover.hold('editor', false); });

    bar(0);
  }

  function init(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-ez-h-sets]'), setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector && e.target.querySelector('[data-ez-h-sets]');
    if (r && r.__ezsSets && r.__ezsSets.mover) { r.__ezsSets.mover.destroy(); r.__ezsSets = null; }
  });
})();
